const defaultPerks: Record<string, string> = {
  employer: '💼',
  address: '📍',
  departments: '🏥',
  headquarters: '🏥',
  vacations: '🌴',
  salary: '💶',
  workingHours: '🕐',
  typeOfHospital: '🏥',
  numberOfBeds: '🛌',
  employmentType: '📄',
  contractTypes: '📄',
  overtimeRegulations: '⏰',
  averageTime: '⏰',
  salaryNegotiations: '💰',
  moreVacancies: '🏥',
  startOfWork: '🗓️',
  typeOfIntensiveCare: '🏥',
  distanceFromHome: '🚗',
  numberOfPatients: '👩',
  distanceOfTravel: '🚗',
  adjustableDistance: '🚗',
  carForPrivateUse: '🚗',
  patientsPerTour: '🚑',
  areaOfPatients: '📍',
  sharedShift: '🕐',
  patientsPerHour: '👩',
  typeOfDepartment: '🏥',
  teamSize: '👫',
  applicationProcess: '🗃️',
  numberOfDoctors: '🧑‍⚕️',
  nursingShare: '⏱️',
  modernityOfDepartment: '🏥',
  postalCode: '📍',
  offerApartments: '🏠',
  averagePeriod: '🗓️',
  interviewWith: '☎️',
};

export default defaultPerks;
